import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.js";

import Login from "../views/Login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/mailing",
    name: "Mailing",
    meta: {
      requireAuth: true,
    },
    component: () => import("../views/Mailing.vue"),
  },
  {
    path: "/statistics",
    name: "Statistics",
    meta: {
      requireAuth: true,
    },
    component: () => import("../views/Statistics.vue"),
  },
  {
    path: "/channels",
    name: "Сhannels",
    meta: {
      requireAuth: true,
    },
    component: () => import("../views/Channels.vue"),
  },
  {
    path: "/knowledge",
    name: "Knowledge",
    meta: {
      requireAuth: true,
    },
    component: () => import("../views/Knowledge.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // если авторизован и идешь на страницу входа, отправляет на главную
  if (to.name == "Login" && store.getters["authorization/isLoggedIn"])
    next({ name: "Statistics" });
  else {
    // если нужна авторизация и не авторизован, отправить на стр. входа
    if (
      to.matched.some((record) => record.meta.requireAuth) &&
      !store.getters["authorization/isLoggedIn"]
    )
      next({ name: "Login" });
    else next();
  }
});
export default router;
